import { useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { LuLogIn, LuAlertCircle, LuEye, LuEyeOff } from "react-icons/lu";
import "../../styles/administrators/signIn.css";
import { API_URL } from "../../utils/api";
import { AUTH_LOGIN } from "../../reducers/authReducer";


//CONNEXION À L'ESPACE MEMBRES (administrateurs et contributeurs : le rôle est détecté par le serveur)
function SignIn() {

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errors, setErrors] = useState([]);

  const dispatch = useDispatch();
  const auth = useSelector((state) => state.authReducer);
  const location = useLocation();

  //Déjà connecté : direction la page demandée au départ, sinon le back office
  if (auth) {
    return <Navigate to={location.state?.from || "/backofficemainpage"} replace />
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!email.trim() || !password) {
      setErrors(["Merci de saisir votre e-mail et votre mot de passe."]);
      return;
    }

    setIsSubmitting(true);
    setErrors([]);
    try {
      const response = await fetch(`${API_URL}/authRoute/signin`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ emailFromFront: email.trim(), passwordFromFront: password }),
      });
      const body = await response.json();
      if (body.result === true) {
        //La redirection se fait au prochain affichage, dès que "auth" est rempli
        dispatch({ type: AUTH_LOGIN, payload: { token: body.token, user: body.user } });
        return;
      }
      setErrors(body.error);
    } catch (error) {
      setErrors(["Connexion impossible pour le moment. Merci de réessayer."]);
    }
    setIsSubmitting(false);
  };

  return (
    <main className="signin">
      <header className="page-hero">
        <div className="wrap page-hero_content">
          <p className="page-hero_eyebrow">
            <span className="tricolor" aria-hidden="true"><span></span><span></span><span></span></span>
            Espace membres
          </p>
          <h1 className="page-hero_title">Connexion</h1>
          <p className="page-hero_text">Accès réservé aux administrateurs et contributeurs du club.</p>
        </div>
      </header>

      <div className="wrap">
        <form className="signin_card surface" onSubmit={handleSubmit} noValidate>
          <div className="field">
            <label className="field_label" htmlFor="signinEmail">E-mail</label>
            <input className="field_control" id="signinEmail" type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>

          <div className="field">
            <label className="field_label" htmlFor="signinPassword">Mot de passe</label>
            <div className="signin_password">
              <input className="field_control" id="signinPassword" type={showPassword ? "text" : "password"} autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} />
              <button type="button" className="signin_password_toggle" onClick={() => setShowPassword(!showPassword)} aria-label={showPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"}>
                {showPassword ? <LuEyeOff aria-hidden="true" /> : <LuEye aria-hidden="true" />}
              </button>
            </div>
          </div>

          {errors.length > 0 && (
            <div className="msg msg--error signin_message" role="alert">
              <LuAlertCircle aria-hidden="true" />
              <div>{errors.map((error) => <p key={error}>{error}</p>)}</div>
            </div>
          )}

          <button type="submit" className="btn btn--primary btn--lg signin_button" disabled={isSubmitting}>
            <LuLogIn aria-hidden="true" /> {isSubmitting ? "Connexion…" : "Se connecter"}
          </button>

          <p className="signin_hint">Pas de compte ? Demandez à un administrateur du club de vous en créer un.</p>
        </form>
      </div>
    </main>
  )
};

export default SignIn;
